// extracted by mini-css-extract-plugin
export default {"content":"Dashboard_content__eAg1L"};